import { NgModule }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { JwtModule } from '@auth0/angular-jwt';
import { AngularMaterialModule } from '../angular-material.module';

import { AuthzoneComponent } from './authzone.component';
import { AuthzoneSideMenuComponent } from './authzone-side-menu/authzone-side-menu.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    RouterModule,
    TranslateModule
    //JwtModule.forRoot({
    //  config: {
    //    tokenGetter: function  tokenGetter() { return localStorage.getItem('token'); },
        //whitelistedDomains: ['localhost:3000'],
        //blacklistedRoutes: ['http://localhost:3000/auth/login']
    //  }
    //})
  ],
  declarations: [
    AuthzoneComponent,
    AuthzoneSideMenuComponent
  ],
  exports:      [ AuthzoneComponent, AuthzoneSideMenuComponent ],
  providers:    [ ]
})

export class AuthzoneModule { }
